import { OidcClient } from "@axa-fr/react-oidc";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { OidcContext } from "../types/oidcTypes";
import { getOidcConfigurationForContext } from "./oidcConfiguration";

export function createRedirectUri(path: string): string {
  const baseUrl = environment.NX_AVENGERS_BASE_URL.replaceAll(/\/$/g, "");
  path = path.replaceAll(/^\//g, "");
  return baseUrl + "/" + path;
}

export function getOrCreateOidcClient(oidcContext: OidcContext): OidcClient {
  const getOrCreateOidc = OidcClient.getOrCreate(() => fetch);
  return getOrCreateOidc(getOidcConfigurationForContext(oidcContext), oidcContext);
}

export function logoutFromNonDefaultOidcContexts(): Promise<void> {
  const logoutPromises = Object.values(OidcContext)
    .filter((it) => it !== OidcContext.DEFAULT)
    .map((oidcContext) => getOrCreateOidcClient(oidcContext).logoutAsync(null, {
      // "no_reload:oidc" prevents the OIDC client from redirecting to the IdP
      "no_reload:oidc": "true",
    }));

  return Promise.all(logoutPromises).then();
}

const preAuthenticationPathKey = "preAuthenticationPath";
export const persistPreAuthenticationPathIfNoneIsSet = () => {
  if (getPreAuthenticationPath() == null) sessionStorage.setItem(preAuthenticationPathKey, location.pathname);
};

export const getPreAuthenticationPath = (): string | null => {
  return sessionStorage.getItem(preAuthenticationPathKey);
};

export const clearPreAuthenticationPath = () => {
  sessionStorage.removeItem(preAuthenticationPathKey);
};
